import { TicketStatusEnum } from "@/lib/enum/ticket-status.enum";
import { PageFilterOperationEnum } from "@/lib/utility/data/page-filter-operation.enum";
import { formatYearsMonthDay } from "@/lib/utility/date-helper";
import { PageFilterElement } from "@/models/page-filter-element.entity";
import { PredefinedFilterType } from "@/views/event/filter/event.filter";

export const predefinedTicketFilter: PredefinedFilterType[] = [
  {
    name: "components.FilterCardPagination.predefinedFilter.ticket.closed",
    filter: [
      new PageFilterElement({
        key: "state",
        operation: PageFilterOperationEnum.EQUAL,
        value: TicketStatusEnum.CLOSED
      })
    ]
  },
  {
    name: "components.FilterCardPagination.predefinedFilter.ticket.drafts",
    filter: [
      new PageFilterElement({
        key: "state",
        operation: PageFilterOperationEnum.EQUAL,
        value: TicketStatusEnum.DRAFT
      })
    ]
  },
  {
    name: "components.FilterCardPagination.predefinedFilter.ticket.overdue",
    filter: [
      new PageFilterElement({
        key: "due",
        operation: PageFilterOperationEnum.LESS_EQUAL,
        value: formatYearsMonthDay(new Date())
      }),
      new PageFilterElement({
        key: "state",
        operation: PageFilterOperationEnum.EQUAL,
        value: TicketStatusEnum.OPEN
      })
    ]
  }
];
